import React from 'react';

const EditGradientIcon = ({ size = 24, onClick, style = {}, ...props }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 30 30" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg" 
    onClick={onClick}
    style={{ cursor: 'pointer', ...style }} 
    {...props}
  >
    <g clipPath="url(#clip0_3308_3704)">
      <path 
        d="M15 25H26.25" 
        stroke="url(#paint0_linear_3308_3704)" 
        strokeWidth="3" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      <path 
        d="M22.5 2.09836C23.0452 2.09836 23.5852 2.20613 24.0889 2.41476C24.5924 2.62338 25.0501 2.92879 25.4355 3.31418C25.821 3.69964 26.1273 4.15724 26.3359 4.66086C26.5445 5.16447 26.6513 5.70462 26.6514 6.24973C26.6514 6.79484 26.5445 7.33497 26.3359 7.83859C26.1273 8.34223 25.821 8.79978 25.4355 9.18527L9.81055 24.8103C9.61844 25.0024 9.3778 25.1388 9.11426 25.2048L4.11426 26.4548C3.6031 26.5826 3.06202 26.4328 2.68945 26.0603C2.31703 25.6878 2.16723 25.1475 2.29492 24.6364L3.54492 19.6364L3.60742 19.4431C3.68261 19.2551 3.79529 19.0833 3.93945 18.9392L19.5645 3.31418C20.343 2.53568 21.399 2.09836 22.5 2.09836Z" 
        stroke="url(#paint1_linear_3308_3704)" 
        strokeWidth="2.5" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <linearGradient id="paint0_linear_3308_3704" x1="31.7684" y1="26.4664" x2="30.1309" y2="20.7019" gradientUnits="userSpaceOnUse">
        <stop stopColor="#F3109E"/>
        <stop offset="1" stopColor="#181C84"/>
      </linearGradient>
      <linearGradient id="paint1_linear_3308_3704" x1="35.6496" y1="34.9815" x2="-2.34959" y2="23.0906" gradientUnits="userSpaceOnUse">
        <stop stopColor="#F3109E"/>
        <stop offset="1" stopColor="#181C84"/>
      </linearGradient>
      <clipPath id="clip0_3308_3704">
        <rect width="30" height="30" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);

export default EditGradientIcon;